export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_planning_editor') || '企划编辑',
    icon: 'el-icon-edit-outline',
    menuType: 'planningEditor',
    divided: true,
    disabled: ({ amzPurchaseCode }) => {
      return that.disabled || that.designDisabled || !!amzPurchaseCode
    },
  },
  {
    text: that.$l('menu_text_delete_goods') || '删除产品 ',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    disabled: ({ amzPurchaseCode }) => {
      return that.disabled || that.prohibit || !!amzPurchaseCode
    },
  },
  {
    text: that.$l('menu_text_operations_editor') || '运营编辑',
    icon: 'el-icon-tickets',
    menuType: 'operationsEditor',
    divided: true,
    disabled: ({ amzPurchaseCode }) => {
      return that.disabled || that.operateDisabled || !!amzPurchaseCode
    },
  },
]
